import _ from 'lodash';
import React from 'react';

const exported = {
  isBlank: /^\.|^\-$|\-\.|^$/,
  isNegative: /^-/,
  isInteger: /^\-?\d{1,}$/,
  isDecimal: /^\-?\d*\.\d*$/,
  toTruncLeft: /^(\-)?0\d{1,}/,
  truncLeft: /^\-?\b0*([1-9][0-9]*|0)\b/,

  format: function (val, decimals, start) {
    let dp = decimals || this.props.decimals;
    return dp > 0 ? this.toDecimal(val, dp, start) : this.toInteger(val, start);
  },

  toInteger: function (val, start) {
    val = (val || 0).toString();

    if (val.match(this.isBlank))
      val = val.match(this.isNegative) ? '-0' + val.substring(1) : '0' + val;

    if (!val.match(this.isInteger)) return this.get();

    if (val.match(this.toTruncLeft)) {
      let neg = val.match(this.isNegative);
      val = (neg ? '-' : '') + val.replace(this.truncLeft, val.match(this.truncLeft)[1]);
      if (start >= 0) this.setState({ caret: start });
    }

    return val;
  },

  toDecimal: function (newValue, start, changeCallback) {
    let { caret, value } = this.state;

    newValue === 0 ? (value = '0') : (value = (newValue || value || 0).toString());

    let dp = this.props.decimals;

    if (this.isBlank.test(value)) {
      value = value.match(this.isNegative) ? '-0' + value.substring(1) : '0' + value;
      if (parseFloat(value) === 0.0) caret = start;
      else if (start >= 0) caret = start;
    }

    if (!/\./.test(value)) {
      value += '.' + this.pad(dp);
      if (start >= 0) caret = start;
    }

    if (!this.isDecimal.test(value)) {
      this.setState({ caret }, changeCallback);
      return;
    }

    if (this.toTruncLeft.test(value)) {
      let neg = value.match(this.isNegative);
      let diff = value.length;
      value = (neg ? '-' : '') + value.replace(this.truncLeft, value.match(this.truncLeft)[1]);
      diff -= value.length;
      if (start >= 0) caret = start == (neg ? 1 : 0) ? start : start - diff;
    }

    let padRight = new RegExp('\\.\\d{0,' + (parseInt(dp) - 1) + '}$');
    let toTruncRight = new RegExp('\\.\\d{' + (parseInt(dp) + 1) + ',}');

    if (padRight.test(value)) value = value + this.pad(dp);

    if (toTruncRight.test(value)) {
      const shift = Math.pow(10, dp);
      value = (Math.round(value * shift) / shift).toFixed(dp);
      if (start >= 0) caret = start < value.length ? start : value.length;
    }

    value = this.limit(value, this.props.min, this.props.max);
    value = parseFloat(value).toFixed(this.props.decimals);
    this.setState({ caret, value }, changeCallback);
  },

  pad: function (n) {
    return Math.pow(10, n).toString().slice(1);
  },

  truncToDecimals: function (value, dp) {
    return value.match(new RegExp('\\.\\d{' + (parseInt(dp) + 1) + ',}'))
      ? value.match(new RegExp('^\\-?\\d*\\.\\d{' + dp + '}'))[0]
      : value;
  },

  max: function (value, _max) {
    let max = parseFloat(_max);
    value = parseFloat(value);
    return value > max ? max : value;
  },

  min: function (value, _min) {
    let min = parseFloat(_min);
    value = parseFloat(value);
    return value < min ? min : value;
  },

  limit: function (value, min, max) {
    if (value == null) return;

    if (!!min || min == 0) value = this.min(value, min);

    if (!!max || max == 0) value = this.max(value, max);

    return value.toString();
  }
};

export default exported;

export const {
  isBlank,
  isNegative,
  isInteger,
  isDecimal,
  toTruncLeft,
  truncLeft,
  format,
  toInteger,
  toDecimal,
  pad,
  truncToDecimals,
  max,
  min,
  limit
} = exported;
